import styled from 'styled-components';

export const Wrapper = styled.div`
  width: 100%;
  padding: 20px 16px;
  background: #fff;
  border-radius: 4px;
  -webkit-font-smoothing: antialiased;
  color: #666;
  font-size: 14px;
  ${({ $variantB }) =>
    !$variantB &&
    `@media (max-width: 768px) {
    box-shadow: rgba(0, 0, 0, 0.2) 0px 2px 4px;
  }`}
`;
